import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { MarketingCharacteristics } from '@app/constants';
import { ShopAddonsLink } from '@app/router/constants';
import { useNavigate } from '@app/hooks';
import { setCurrentShopAddonId } from '@app/redux/addOns';

import { Characteristic, ProductType } from '@mfe/shared/schema-types';
import { getCharacteristicValue } from '@mfe/shared/utils';

import AddonsGridItem from '../AddonsGrid/addons-grid-item';
import { addDiscountToProductType, getPriceAndDiscount, matchAddonWithFreeDiscount, sortByCheapest } from '../../utils';

const GroupedAddonCard = ({ rootAddon }: { rootAddon: ProductType }) => {
  const { t } = useTranslation('ShopAddons');
  const dispatch = useDispatch();
  const { goTo } = useNavigate();

  const productTypes = rootAddon.package_types?.[0].product_types as ProductType[];
  const [cheapestProduct] = sortByCheapest(productTypes as ProductType[]);

  const cheapestProductDiscount = matchAddonWithFreeDiscount(cheapestProduct, rootAddon);

  const cheapestProductWithDiscount = cheapestProductDiscount
    ? addDiscountToProductType(cheapestProduct, cheapestProductDiscount)
    : cheapestProduct;

  const title =
    getCharacteristicValue(
      cheapestProduct?.marketing_copy?.ui_behaviors?.characteristics as Characteristic[],
      MarketingCharacteristics.OFFER_NAME
    ) ?? rootAddon.name;

  const description =
    getCharacteristicValue(
      rootAddon.marketing_copy.translations[0].characteristics,
      MarketingCharacteristics.OFFER_DESCRIPTION
    ) ??
    rootAddon.description ??
    '';

  const { price, oldPrice, promotions = [], totalPromotionDuration } = getPriceAndDiscount(cheapestProductWithDiscount);

  const button = {
    text: t('selectAddon.addToPlanCTALabel', { title }),
    onClick: () => {
      dispatch(setCurrentShopAddonId(rootAddon.id));
      goTo(`${ShopAddonsLink.ShopAddons}/${ShopAddonsLink.GroupedAddon}`);
    },
  };

  const props = {
    kind: rootAddon.kind,
    title,
    oldPrice,
    price,
    promotions,
    description,
    button,
    totalPromotionDuration,
    isGroupedProduct: true,
  };

  return <AddonsGridItem {...props} />;
};

export default GroupedAddonCard;
